import { ChangeEvent, useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { DebouncedTextInputProps } from '../../types/DebouncedTextInputProps';

export const useDebouncedTextInput = (
  onDebouncedChange: DebouncedTextInputProps['onDebouncedChange'],
) => {
  const [search, setSearch] = useState<string>('');

  const onSearchValueChange = useDebouncedCallback((searchString: string) => {
    onDebouncedChange(searchString);
  }, 500);

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setSearch(event.target.value);
      onSearchValueChange(event.target.value);
    },
    [onSearchValueChange, setSearch],
  );

  return {
    search,
    handleInputChange,
  };
};
